// this one is index file to exports all pages or UI for the direct interactions.
// here we are using a Code-Splitting with react.lezy

import { lazy } from "react";

export const PageNotFound = lazy(() => import("./errors/Pagenotfound"));

//dashboard pages
export * from "./dashboard";

// Login Page and store
export * from "./login";

export { default as Callback } from "./callback";
